import React, { useState, useEffect } from "react";
import Loader from "../../../loader/Loader";
import { toast } from "react-toastify";
import axios from "axios";
import { domain } from "../../../../security";

const AddInventoryStatus = ({
  onClose,
  refreshData,
  statusToEdit,
  currentUser,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    isAvailable: true,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (statusToEdit) {
      setFormData({
        name: statusToEdit.name || statusToEdit.Name || "",
        description: statusToEdit.description || statusToEdit.Description || "",
        isAvailable:
          statusToEdit.isAvailable ?? statusToEdit.IsAvailable ?? true,
      });
    }
  }, [statusToEdit]);

  const handleInputChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const apiUrl = `${domain}/api/InventoryStatuses`;

    // We must map the frontend state to the EXACT property names
    // expected by the C# DTOs (AddInventoryStatusDto / UpdateInventoryStatusDto)
    const payload = {
      Name: formData.name,
      Description: formData.description || "",
      IsAvailable: formData.isAvailable,
      UserID: currentUser?.userId || null,
    };

    try {
      if (statusToEdit) {
        // Use Id or id depending on what's available
        const id = statusToEdit.id || statusToEdit.Id;
        await axios.put(`${apiUrl}/${id}`, payload);
        toast.success("Status updated successfully");
      } else {
        await axios.post(apiUrl, payload);
        toast.success("Status added successfully");
      }

      refreshData();
      onClose();
    } catch (error) {
      console.error("Validation Error Details:", error.response?.data?.errors);
      const serverMessage =
        error.response?.data?.title || "Check required fields";
      toast.error(`Error: ${serverMessage}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6">
      {isLoading && <Loader />}
      <div className="relative w-full">
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 p-2 text-gray-500 hover:text-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <h2 className="text-2xl mb-6 font-bold text-gray-800">
          {statusToEdit ? "Edit Inventory Status" : "Add Inventory Status"}
        </h2>

        <form onSubmit={handleFormSubmit} className="space-y-5">
          <div>
            <label
              htmlFor="name"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Status Name
            </label>
            <input
              id="name"
              type="text"
              required
              className="border border-gray-300 rounded-md py-2 px-3 w-full focus:ring-indigo-500 focus:border-indigo-500 outline-none"
              value={formData.name}
              onChange={handleInputChange}
            />
          </div>

          <div>
            <label
              htmlFor="description"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Description
            </label>
            <textarea
              id="description"
              className="border border-gray-300 rounded-md py-2 px-3 w-full h-24 focus:ring-indigo-500 focus:border-indigo-500 outline-none resize-none"
              value={formData.description}
              onChange={handleInputChange}
            />
          </div>

          <div className="flex items-center">
            <input
              id="isAvailable"
              type="checkbox"
              className="h-5 w-5 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
              checked={formData.isAvailable}
              onChange={handleInputChange}
            />
            <label
              htmlFor="isAvailable"
              className="ml-2 block text-sm text-gray-900"
            >
              Item is Available for use/sale
            </label>
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-lg shadow transition-colors"
          >
            {statusToEdit ? "Update Status" : "Add Status"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddInventoryStatus;
